import { ChangeDetectionStrategy, Component, computed, effect, inject, untracked } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '@components/footer/footer.component';
import { NavComponent } from '@components/nav/nav.component';
import { NotificationsPanelComponent } from '@components/notifications-panel/notifications-panel.component';
import { AuthService } from '@services/auth';
import { PageLayoutSettingsService } from '@services/page-layout-settings.service';
import { LicenseTypesStore } from '@store/license-types.store';
import { LoaderComponent, ToastComponent } from 'mbs-ui-kit';

@Component({
  selector: 'mbs-reseller-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterOutlet, ToastComponent, NavComponent, FooterComponent, NotificationsPanelComponent, LoaderComponent]
})
export class LayoutComponent {
  private auth = inject(AuthService);
  private licenseTypesStore = inject(LicenseTypesStore);
  private isLoginPage = inject(PageLayoutSettingsService).isLoginPage;

  protected showHeaderAndFooter = computed(() => !this.isLoginPage() && this.auth.isAuthenticated());
  protected showLoader = computed(() => !this.isLoginPage() && !this.auth.authChecked());

  constructor() {
    effect(() => {
      if (this.auth.isAuthenticated()) {
        untracked(() => this.licenseTypesStore.loadAllLicenseTypes(false));
      }
    });
  }
}
